export default {
  map: {
    'Aa en Hunze': 'Drenthe',
    Aalsmeer: 'Noord-Holland',
    Aalten: 'Gelderland',
    Achtkarspelen: 'Friesland',
    Alblasserdam: 'Zuid-Holland',
    Albrandswaard: 'Zuid-Holland',
    Alkmaar: 'Noord-Holland',
    Almelo: 'Overijssel',
    Almere: 'Flevoland',
    'Alphen aan den Rijn': 'Zuid-Holland',
    'Alphen-Chaam': 'Noord-Brabant',
    Altena: 'Noord-Brabant',
    Ameland: 'Friesland',
    Amersfoort: 'Utrecht',
    Amstelveen: 'Noord-Holland',
    Amsterdam: 'Noord-Holland',
    Apeldoorn: 'Gelderland',
    Appingedam: 'Groningen',
    Arnhem: 'Gelderland',
    Assen: 'Drenthe',
    Asten: 'Noord-Brabant',
    'Baarle-Nassau': 'Noord-Brabant',
    Baarn: 'Utrecht',
    Barendrecht: 'Zuid-Holland',
    Barneveld: 'Gelderland',
    Beek: 'Limburg',
    Beekdaelen: 'Limburg',
    Beemster: 'Noord-Holland',
    Beesel: 'Limburg',
    'Berg en Dal': 'Gelderland',
    Bergeijk: 'Noord-Brabant',
    'Bergen (L.)': 'Limburg',
    'Bergen (NH.)': 'Noord-Holland',
    'Bergen op Zoom': 'Noord-Brabant',
    Berkelland: 'Gelderland',
    Bernheze: 'Noord-Brabant',
    Best: 'Noord-Brabant',
    Beuningen: 'Gelderland',
    Beverwijk: 'Noord-Holland',
    'De Bilt': 'Utrecht',
    Bladel: 'Noord-Brabant',
    Blaricum: 'Noord-Holland',
    Bloemendaal: 'Noord-Holland',
    'Bodegraven-Reeuwijk': 'Zuid-Holland',
    Boekel: 'Noord-Brabant',
    'Borger-Odoorn': 'Drenthe',
    Borne: 'Overijssel',
    Borsele: 'Zeeland',
    Boxmeer: 'Noord-Brabant',
    Boxtel: 'Noord-Brabant',
    Breda: 'Noord-Brabant',
    Brielle: 'Zuid-Holland',
    Bronckhorst: 'Gelderland',
    Brummen: 'Gelderland',
    Brunssum: 'Limburg',
    Bunnik: 'Utrecht',
    Bunschoten: 'Utrecht',
    Buren: 'Gelderland',
    'Capelle aan den IJssel': 'Zuid-Holland',
    Castricum: 'Noord-Holland',
    Coevorden: 'Drenthe',
    Cranendonck: 'Noord-Brabant',
    Cuijk: 'Noord-Brabant',
    Culemborg: 'Gelderland',
    Dalfsen: 'Overijssel',
    Dantumadiel: 'Friesland',
    Delft: 'Zuid-Holland',
    Delfzijl: 'Groningen',
    Deurne: 'Noord-Brabant',
    Deventer: 'Overijssel',
    Diemen: 'Noord-Holland',
    Dinkelland: 'Overijssel',
    Doesburg: 'Gelderland',
    Doetinchem: 'Gelderland',
    Dongen: 'Noord-Brabant',
    Dordrecht: 'Zuid-Holland',
    Drechterland: 'Noord-Holland',
    Drimmelen: 'Noord-Brabant',
    Dronten: 'Flevoland',
    Druten: 'Gelderland',
    Duiven: 'Gelderland',
    'Echt-Susteren': 'Limburg',
    'Edam-Volendam': 'Noord-Holland',
    Ede: 'Gelderland',
    Eemnes: 'Utrecht',
    Eersel: 'Noord-Brabant',
    'Eijsden-Margraten': 'Limburg',
    Eindhoven: 'Noord-Brabant',
    Elburg: 'Gelderland',
    Emmen: 'Drenthe',
    Enkhuizen: 'Noord-Holland',
    Enschede: 'Overijssel',
    Epe: 'Gelderland',
    Ermelo: 'Gelderland',
    'Etten-Leur': 'Noord-Brabant',
    'De Fryske Marren': 'Friesland',
    Geertruidenberg: 'Noord-Brabant',
    'Geldrop-Mierlo': 'Noord-Brabant',
    'Gemert-Bakel': 'Noord-Brabant',
    Gennep: 'Limburg',
    'Gilze en Rijen': 'Noord-Brabant',
    'Goeree-Overflakkee': 'Zuid-Holland',
    Goes: 'Zeeland',
    Goirle: 'Noord-Brabant',
    'Gooise Meren': 'Noord-Holland',
    Gorinchem: 'Zuid-Holland',
    Gouda: 'Zuid-Holland',
    Grave: 'Noord-Brabant',
    '\'s-Gravenhage': 'Zuid-Holland',
    Groningen: 'Groningen',
    'Gulpen-Wittem': 'Limburg',
    Haaksbergen: 'Overijssel',
    Haaren: 'Noord-Brabant',
    Haarlem: 'Noord-Holland',
    Haarlemmermeer: 'Noord-Holland',
    Halderberge: 'Noord-Brabant',
    Hardenberg: 'Overijssel',
    Harderwijk: 'Gelderland',
    'Hardinxveld-Giessendam': 'Zuid-Holland',
    Harlingen: 'Friesland',
    Hattem: 'Gelderland',
    Heemskerk: 'Noord-Holland',
    Heemstede: 'Noord-Holland',
    Heerde: 'Gelderland',
    Heerenveen: 'Friesland',
    Heerhugowaard: 'Noord-Holland',
    Heerlen: 'Limburg',
    'Heeze-Leende': 'Noord-Brabant',
    Heiloo: 'Noord-Holland',
    'Den Helder': 'Noord-Holland',
    Hellendoorn: 'Overijssel',
    Hellevoetsluis: 'Zuid-Holland',
    Helmond: 'Noord-Brabant',
    'Hendrik-Ido-Ambacht': 'Zuid-Holland',
    Hengelo: 'Overijssel',
    '\'s-Hertogenbosch': 'Noord-Brabant',
    Heumen: 'Gelderland',
    Heusden: 'Noord-Brabant',
    Hillegom: 'Zuid-Holland',
    Hilvarenbeek: 'Noord-Brabant',
    Hilversum: 'Noord-Holland',
    'Hoeksche Waard': 'Zuid-Holland',
    'Hof van Twente': 'Overijssel',
    'Het Hogeland': 'Groningen',
    'Hollands Kroon': 'Noord-Holland',
    Hoogeveen: 'Drenthe',
    Hoorn: 'Noord-Holland',
    'Horst aan de Maas': 'Limburg',
    Houten: 'Utrecht',
    Huizen: 'Noord-Holland',
    Hulst: 'Zeeland',
    IJsselstein: 'Utrecht',
    'Kaag en Braassem': 'Zuid-Holland',
    Kampen: 'Overijssel',
    Kapelle: 'Zeeland',
    Katwijk: 'Zuid-Holland',
    Kerkrade: 'Limburg',
    Koggenland: 'Noord-Holland',
    'Krimpen aan den IJssel': 'Zuid-Holland',
    Krimpenerwaard: 'Zuid-Holland',
    Laarbeek: 'Noord-Brabant',
    Landerd: 'Noord-Brabant',
    Landgraaf: 'Limburg',
    Landsmeer: 'Noord-Holland',
    Langedijk: 'Noord-Holland',
    Lansingerland: 'Zuid-Holland',
    Laren: 'Noord-Holland',
    Leeuwarden: 'Friesland',
    Leiden: 'Zuid-Holland',
    Leiderdorp: 'Zuid-Holland',
    'Leidschendam-Voorburg': 'Zuid-Holland',
    Lelystad: 'Flevoland',
    Leudal: 'Limburg',
    Leusden: 'Utrecht',
    Lingewaard: 'Gelderland',
    Lisse: 'Zuid-Holland',
    Lochem: 'Gelderland',
    'Loon op Zand': 'Noord-Brabant',
    Lopik: 'Utrecht',
    Loppersum: 'Groningen',
    Losser: 'Overijssel',
    Maasdriel: 'Gelderland',
    Maasgouw: 'Limburg',
    Maassluis: 'Zuid-Holland',
    Maastricht: 'Limburg',
    Medemblik: 'Noord-Holland',
    Meerssen: 'Limburg',
    Meierijstad: 'Noord-Brabant',
    Meppel: 'Drenthe',
    Middelburg: 'Zeeland',
    'Midden-Delfland': 'Zuid-Holland',
    'Midden-Drenthe': 'Drenthe',
    'Midden-Groningen': 'Groningen',
    'Mill en Sint Hubert': 'Noord-Brabant',
    Moerdijk: 'Noord-Brabant',
    Molenlanden: 'Zuid-Holland',
    Montferland: 'Gelderland',
    Montfoort: 'Utrecht',
    'Mook en Middelaar': 'Limburg',
    'Neder-Betuwe': 'Gelderland',
    Nederweert: 'Limburg',
    Nieuwegein: 'Utrecht',
    Nieuwkoop: 'Zuid-Holland',
    Nijkerk: 'Gelderland',
    Nijmegen: 'Gelderland',
    Nissewaard: 'Zuid-Holland',
    'Noardeast-Fryslân': 'Friesland',
    'Noord-Beveland': 'Zeeland',
    Noordenveld: 'Drenthe',
    Noordoostpolder: 'Flevoland',
    Noordwijk: 'Zuid-Holland',
    'Nuenen, Gerwen en Nederwetten': 'Noord-Brabant',
    Nunspeet: 'Gelderland',
    Oegstgeest: 'Zuid-Holland',
    Oirschot: 'Noord-Brabant',
    Oisterwijk: 'Noord-Brabant',
    Oldambt: 'Groningen',
    Oldebroek: 'Gelderland',
    Oldenzaal: 'Overijssel',
    'Olst-Wijhe': 'Overijssel',
    Ommen: 'Overijssel',
    'Oost Gelre': 'Gelderland',
    Oosterhout: 'Noord-Brabant',
    Ooststellingwerf: 'Friesland',
    Oostzaan: 'Noord-Holland',
    Opmeer: 'Noord-Holland',
    Opsterland: 'Friesland',
    Oss: 'Noord-Brabant',
    'Oude IJsselstreek': 'Gelderland',
    'Ouder-Amstel': 'Noord-Holland',
    Oudewater: 'Utrecht',
    Overbetuwe: 'Gelderland',
    Papendrecht: 'Zuid-Holland',
    'Peel en Maas': 'Limburg',
    Pekela: 'Groningen',
    'Pijnacker-Nootdorp': 'Zuid-Holland',
    Purmerend: 'Noord-Holland',
    Putten: 'Gelderland',
    Raalte: 'Overijssel',
    Reimerswaal: 'Zeeland',
    Renkum: 'Gelderland',
    Renswoude: 'Utrecht',
    'Reusel-De Mierden': 'Noord-Brabant',
    Rheden: 'Gelderland',
    Rhenen: 'Utrecht',
    Ridderkerk: 'Zuid-Holland',
    'Rijssen-Holten': 'Overijssel',
    Rijswijk: 'Zuid-Holland',
    Roerdalen: 'Limburg',
    Roermond: 'Limburg',
    'De Ronde Venen': 'Utrecht',
    Roosendaal: 'Noord-Brabant',
    Rotterdam: 'Zuid-Holland',
    Rozendaal: 'Gelderland',
    Rucphen: 'Noord-Brabant',
    Schagen: 'Noord-Holland',
    Scherpenzeel: 'Gelderland',
    Schiedam: 'Zuid-Holland',
    Schiermonnikoog: 'Friesland',
    'Schouwen-Duiveland': 'Zeeland',
    Simpelveld: 'Limburg',
    'Sint Anthonis': 'Noord-Brabant',
    'Sint-Michielsgestel': 'Noord-Brabant',
    'Sittard-Geleen': 'Limburg',
    Sliedrecht: 'Zuid-Holland',
    Sluis: 'Zeeland',
    Smallingerland: 'Friesland',
    Soest: 'Utrecht',
    Someren: 'Noord-Brabant',
    'Son en Breugel': 'Noord-Brabant',
    Stadskanaal: 'Groningen',
    Staphorst: 'Overijssel',
    'Stede Broec': 'Noord-Holland',
    Steenbergen: 'Noord-Brabant',
    Steenwijkerland: 'Overijssel',
    Stein: 'Limburg',
    'Stichtse Vecht': 'Utrecht',
    'Súdwest-Fryslân': 'Friesland',
    Terneuzen: 'Zeeland',
    Terschelling: 'Friesland',
    Texel: 'Noord-Holland',
    Teylingen: 'Zuid-Holland',
    Tholen: 'Zeeland',
    Tiel: 'Gelderland',
    Tilburg: 'Noord-Brabant',
    Tubbergen: 'Overijssel',
    Twenterand: 'Overijssel',
    Tynaarlo: 'Drenthe',
    Tytsjerksteradiel: 'Friesland',
    Uden: 'Noord-Brabant',
    Uitgeest: 'Noord-Holland',
    Uithoorn: 'Noord-Holland',
    Urk: 'Flevoland',
    Utrecht: 'Utrecht',
    'Utrechtse Heuvelrug': 'Utrecht',
    Vaals: 'Limburg',
    'Valkenburg aan de Geul': 'Limburg',
    Valkenswaard: 'Noord-Brabant',
    Veendam: 'Groningen',
    Veenendaal: 'Utrecht',
    Veere: 'Zeeland',
    Veldhoven: 'Noord-Brabant',
    Velsen: 'Noord-Holland',
    Venlo: 'Limburg',
    Venray: 'Limburg',
    Vijfheerenlanden: 'Utrecht',
    Vlaardingen: 'Zuid-Holland',
    Vlieland: 'Friesland',
    Vlissingen: 'Zeeland',
    Voerendaal: 'Limburg',
    Voorschoten: 'Zuid-Holland',
    Voorst: 'Gelderland',
    Vught: 'Noord-Brabant',
    Waadhoeke: 'Friesland',
    Waalre: 'Noord-Brabant',
    Waalwijk: 'Noord-Brabant',
    Waddinxveen: 'Zuid-Holland',
    Wageningen: 'Gelderland',
    Wassenaar: 'Zuid-Holland',
    Waterland: 'Noord-Holland',
    Weert: 'Limburg',
    Weesp: 'Noord-Holland',
    'West Betuwe': 'Gelderland',
    'West Maas en Waal': 'Gelderland',
    Westerkwartier: 'Groningen',
    Westerveld: 'Drenthe',
    Westervoort: 'Gelderland',
    Westerwolde: 'Groningen',
    Westland: 'Zuid-Holland',
    Weststellingwerf: 'Friesland',
    Westvoorne: 'Zuid-Holland',
    Wierden: 'Overijssel',
    Wijchen: 'Gelderland',
    Wijdemeren: 'Noord-Holland',
    'Wijk bij Duurstede': 'Utrecht',
    Winterswijk: 'Gelderland',
    Woensdrecht: 'Noord-Brabant',
    Woerden: 'Utrecht',
    'De Wolden': 'Drenthe',
    Wormerland: 'Noord-Holland',
    Woudenberg: 'Utrecht',
    Zaanstad: 'Noord-Holland',
    Zaltbommel: 'Gelderland',
    Zandvoort: 'Noord-Holland',
    Zeewolde: 'Flevoland',
    Zeist: 'Utrecht',
    Zevenaar: 'Gelderland',
    Zoetermeer: 'Zuid-Holland',
    Zoeterwoude: 'Zuid-Holland',
    Zuidplas: 'Zuid-Holland',
    Zundert: 'Noord-Brabant',
    Zutphen: 'Gelderland',
    Zwartewaterland: 'Overijssel',
    Zwijndrecht: 'Zuid-Holland',
    Zwolle: 'Overijssel',
  },
};
